















































































































































































// import Vue from 'vue';
// import { VNode, CreateElement } from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { TableEntry, TableColumnConfig } from '@libs-uuif/shared/sw-table';
import { SelectedUserGroupObjectType, ScopeProductGroup, MsspPrefilterList, MSSPPrefilterResponseType } from './userGroupTypes';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import UUIFComponents from '@/shared/uuifComponent';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { currentUserKey } from '@/shared/msw-constants';

const cssPrefix = 'scope-container';
@Component({
  components: {
    ...UUIFComponents,
    SwCheckbox,
    SwScrollView,
  },
})
export default class ScopeContainer  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  allTenant: boolean = true;
  searchString: string = '';
  scopeSelected = '';
  editMode: boolean = true;
  filteredData: TableEntry[] = [];
  permissionCheckBox : string[] = [];
  userGroupDataEntry: SelectedUserGroupObjectType = {
    partyGroupName: '',
    isDefaultGroup: '',
    partyGroupId: '',
    adminPartyId: '',
    status: '',
    totalContacts: '',
    productGroupName: '',
    associatedPGList: [],
    setAsDefaultGroup: '',
    renameLink: '',
    usersForUserGroup: [],
    deleteLink: '',
    mgeProdGrpPagelink: '',
    isReadOnlyAccess: '',
    MSSPID: '',
    isAllMSSPTenants: '',
    msspScope: '',
    scopedMSSPID: '',
  };
  scopeTenantDataEntry: TableEntry[] = [];
  scopeMsspDataEntry: TableEntry[] = [];
  selectedMssp: string = '';
  // editMsspToggle: boolean = false;
  disableGlobalEdit: boolean = false;
  makeMsspApiCall: boolean = false;
  makeTenantApiCall: boolean = false;
  selectedMsspName: string = '';
  selectedMsspDetailsObj: MsspPrefilterList = {
    MSSPName: '',
    MSSPID: 0,
    Tenants: [],
    isGlobal: '',
  };
  isREstrictedMsspFromApi: string = '';
  disableSaveBtn: boolean = false;

  @Prop()
  activeMssp: SelectOption[];

  @Prop({ required: false , type : String })
  msspName: string;

  @Prop()
  msspPrefilterResponse: MSSPPrefilterResponseType;

  discardChanges() {
    confirmService.confirm({
      status: 'major',
      title: String(this.$t('accessMgmt.userScope')),
      message: String(this.$t('accessMgmt.discard')),
      buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.confirm')), isDefault: true }],
    })
    .then((isConfirmed : any) => {
      if (isConfirmed === 'ok') {
        this.formatUsersTable();
        this.editMode = true;
      }
    });
  }

  onChangeEdit() {
    if ((this.allTenant !== (this.userGroupDataEntry.msspScope === 'GLOBAL')) && this.allTenant) {
      this.makeMsspApiCall = true;
    }
    if (this.scopeSelected === 'tenant' && this.permissionCheckBox.length === 0) {
      this.makeTenantApiCall = false;
    }
    if (!this.editMode) {
      confirmService.confirm({
        status: 'major',
        title: String(this.$t('accessMgmt.userScope')),
        message: String(this.$t('accessMgmt.changeScope')),
        buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.confirm')), isDefault: true }],
      })
      .then((isConfirmed : any) => {
        if (isConfirmed === 'ok') {
          this.$emit('onSaveScopeMssp', this.allTenant, this.selectedMssp, this.permissionCheckBox, this.scopeSelected, this.makeMsspApiCall, this.makeTenantApiCall);
        } else {
          this.formatUsersTable();
        }
      });
    }
    this.editMode = !this.editMode;
  }

  onTenantChange() {
    this.scopeSelected = 'tenant';
    const scope: any = [];
    if (this.allTenant) {
      this.getScopeUserGroup.assignedProductGroup.map((ele: ScopeProductGroup, index: number) => {
        if (ele.isMSSPFlagged === 'TRUE') {
          scope.push({
            _key: index.toString(),
            productGroupId: ele.productGroupId,
            productGroupName: ele.productGroupName,
          });
          this.permissionCheckBox.push(ele.productGroupId);
        }
      });
      this.filteredData = [...scope];
    } else {
      this.filteredData = [...this.scopeTenantDataEntry];
    }
    console.warn(this.filteredData);
  }

  onChangeScope() {
    const selectedTableData = this.scopeSelected === 'tenant' ? this.scopeTenantDataEntry : this.scopeMsspDataEntry;
    if (this.scopeSelected === 'tenant') {
      this.makeTenantApiCall = true;
    } else {
      this.makeTenantApiCall = false;
    }
    if (this.scopeSelected === 'mssp') {
      this.makeMsspApiCall = true;
    } else {
      this.makeMsspApiCall = false;
    }
    this.filteredData = [...selectedTableData];
    if (this.checkForMasterMsspRole) {
      this.getScopeUserGroup?.assignedProductGroup?.map((ele: any) => {
        this.permissionCheckBox.push(ele.productGroupId);
      });
    } else {
      this.permissionCheckBox = [];
    }
  }

  onChangeScopeForAllTenants() {
    this.permissionCheckBox = [];
    this.makeTenantApiCall = true;
    this.filteredData = [...this.scopeTenantDataEntry];
    this.filteredData?.map((ele: any) => {
      this.permissionCheckBox.push(ele.productGroupId);
    });
  }

  onChangeTenant() {
    if (this.permissionCheckBox.length > 0) {
      this.makeTenantApiCall = true;
      this.disableSaveBtn = false;
    } else {
      this.disableSaveBtn = true;
    }
  }

  onChangeMssp() {
    this.makeMsspApiCall = true;
  }

  performSearch() {
    const obj = this.searchString.toString()
    .toLocaleLowerCase();
    const searchData: TableEntry[] = this.scopeSelected === 'tenant' ? this.scopeTenantDataEntry : this.scopeMsspDataEntry;
    if (this.scopeSelected === 'tenant') {
      if (obj !== '') {
        this.filteredData = searchData.filter((row: any) => {
          let flag = false;
          for (const key in row) {
            if (Object.prototype.hasOwnProperty.call(row, key)) {
              flag = row[key] ? row[key].toString()
              .toLocaleLowerCase()
              .includes(obj) : false;
              if (flag) {
                return flag;
              }
            }
          }
          return false;
        });
      } else {
        const selectedTableData = this.scopeSelected === 'tenant' ? this.scopeTenantDataEntry : this.scopeMsspDataEntry;
        this.filteredData = [...selectedTableData];
      }
    }
  }

  get usersEntry() {
    return this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'];
  }

  scopeColumnConfig: TableColumnConfig[] = [{
    key: 'name',
    dataKey: 'name',
    title: String(this.$t('accessMgmt.name')),
  }];

  get getScopeUserGroup() {
    return this.$store.getters['AccessManagementStoreModule/getUserGroupScopeData'];
  }

  get checkForMasterMsspRole() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles && userInfoObtained.roles.includes('MASTERMSSP')) {
      return true;
    }
    return false;
  }

  @Watch('getScopeUserGroup')
  formatUsersTable() {
    this.makeMsspApiCall = false;
    this.makeTenantApiCall = false;
    this.userGroupDataEntry = this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'];
    const selectedMssp = this.$store.getters['AccessManagementStoreModule/getSelectedMssp'];
    this.isREstrictedMsspFromApi = this.$store.getters['AccessManagementStoreModule/getisRestrictedMSSPAccess'];
    const availableList = [...this.getScopeUserGroup.availbleProductGroup] || [];
    const assignedList = [...this.getScopeUserGroup.assignedProductGroup] || [];
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    const selectedMsspDetails = this.$store.getters['AccessManagementStoreModule/getSelectedMsspObject'];
    this.selectedMsspDetailsObj = selectedMsspDetails;
    this.allTenant = this.userGroupDataEntry.msspScope === 'GLOBAL' ? true : this.userGroupDataEntry.isDefaultGroup === 'TRUE' ? true : false;
    this.disableGlobalEdit = userInfoObtained.roles ? userInfoObtained.roles.includes('MASTERMSSP') ? false : true : true;
    this.scopeTenantDataEntry = [];
    this.scopeMsspDataEntry = [];
    this.permissionCheckBox = [];
    this.scopeSelected = '';
    let scopeTenant: any = [];
    assignedList.map((ele: ScopeProductGroup, index: number) => {
      if (ele.isMSSPFlagged === 'TRUE') {
        this.scopeTenantDataEntry.push({
          _key: index.toString(),
          productGroupId: ele.productGroupId,
          productGroupName: ele.productGroupName,
        });
        this.permissionCheckBox.push(ele.productGroupId);
        scopeTenant = [...this.scopeTenantDataEntry];
      }
    });
    availableList.map((ele: ScopeProductGroup, index: number) => {
      if (ele.isMSSPFlagged === 'TRUE') {
        this.scopeTenantDataEntry.push({
          _key: index.toString(),
          productGroupId: ele.productGroupId,
          productGroupName: ele.productGroupName,
        });
      }
    });
    this.activeMssp.map((ele: SelectOption, index: number) => {
      if (ele.id !== '') {
        this.scopeMsspDataEntry.push({
          _key: index.toString(),
          MSSPId: ele.id,
          msspName: ele.label,
        });
      }
      if (ele.id === selectedMssp) {
        this.selectedMsspName = ele.label.toString();
      }
    });
    // this.editMsspToggle = userInfoObtained.roles ? userInfoObtained.roles.includes('MASTERMSSP') ? true : false : false;
    if (this.userGroupDataEntry.msspScope === 'MSSP' && this.checkForMasterMsspRole) {
      this.scopeSelected = 'mssp';
    } else if (this.userGroupDataEntry.msspScope === 'MSSP' && !this.checkForMasterMsspRole) {
      this.scopeSelected = 'allTenants';
    } else if (this.userGroupDataEntry.msspScope === 'TENANTS' || this.userGroupDataEntry.msspScope === 'GLOBAL') {
      this.scopeSelected = 'tenant';
    }
    this.filteredData = this.scopeSelected === 'mssp' ? [...this.scopeMsspDataEntry] : this.allTenant ? scopeTenant : [...this.scopeTenantDataEntry];
    this.selectedMssp = this.userGroupDataEntry.scopedMSSPID;
  }

  getMsspListCondition(item: TableEntry) {
    return this.checkForMasterMsspRole && this.selectedMsspDetailsObj.isGlobal === 'YES' ? (this.fetchSelectedMsspDetails(item.MSSPId).isGlobal === 'YES') ? false : true : (this.selectedMssp === item.MSSPId);
  }

  fetchSelectedMsspDetails(id: string) {
    let msspDetails = {
      MSSPName: '',
      MSSPID: 0,
      Tenants: [],
      isGlobal: '',
    };
    this.msspPrefilterResponse.content.MSSPs.map((ele: any) => {
      if (ele.MSSPID.toString() === id) {
        msspDetails = Object.assign({}, {
          MSSPName: ele.MSSPName,
          MSSPID: ele.MSSPID,
          Tenants: ele.Tenants || [],
          isGlobal: ele.isGlobal,
        });
      }
    });
    return msspDetails;
  }

  created() {
    this.formatUsersTable();
  }

}
